import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

function ToolTip({ children, placement, toolTipContent }) {
  return (
    <>
      <OverlayTrigger
        placement={placement}
        delay={{ show: 750, hide: 400 }}
        overlay={({ placement, arrowProps, ...props }) => (
          <Tooltip
            {...props}
            arrowProps={arrowProps}
            style={{
              backgroundColor: "#090909",
              color: "white",
              padding: "8px  ",
              borderRadius: "4px",
              fontSize: "14px",
              marginBottom: "12px",
              fontFamily: "open sans",
              overflowX: "auto",
              ...props.style,
            }}>
            {toolTipContent}
          </Tooltip>
        )}>
        {children}
      </OverlayTrigger>
    </>
  );
}

export default ToolTip;
